import { api } from "./api";

// Modelos de certificado (arte, assinaturas, cidade e texto padrão).
export const listarModelos = (incluirInativos = false) =>
  api.get(`/certificado-modelo/listar${incluirInativos ? "?incluirInativos=true" : ""}`);
export const obterModelo = (id) => api.get(`/certificado-modelo/${id}`);
export const salvarModelo = (dto) => api.post("/certificado-modelo/salvar", dto);
export const excluirModelo = (id) => api.post(`/certificado-modelo/excluir/${id}`);

export const uploadArteModelo = (id, tipo, arquivo) => {
  const fd = new FormData();
  fd.append("arquivo", arquivo);
  return api.post(`/certificado-modelo/${id}/arte/${tipo}`, fd, { headers: { "Content-Type": undefined } });
};
export const removerArteModelo = (id, tipo) => api.post(`/certificado-modelo/${id}/arte/${tipo}/remover`);
export const arteModeloUrl = (id, tipo) => `/api/certificado-modelo/${id}/arte-img/${tipo}`;

// Prévia em PDF, aberta numa aba nova (respeita o token).
const abrirPdf = async (rota) => {
  const { data } = await api.get(rota, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
  window.open(url, "_blank");
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};
export const previaModelo = (id, texto) =>
  abrirPdf(`/certificado-modelo/${id}/previa${texto ? `?texto=${encodeURIComponent(texto)}` : ""}`);
export const previaCertificadoEvento = (idEvento) => abrirPdf(`/evento/${idEvento}/certificado/previa`);
